export default __webpack_public_path__ + "28c5ca1.png";